import { ResourcesDownload } from './resources/ResourcesDownload';

export class ResourcesPage {
  constructor() {
    this.download = new ResourcesDownload();
  }
}
